import config from 'src/config.js'
import { getCv } from '@/services/client'

export type ContentToken = {
  token: string
  version: 'draft' | 'published'
  urlParams: string
  cv: number
}

export type createContentUrlParams = {
  isDraft?: boolean
  isPartnerPortalContent?: boolean
}

export const tokens = {
  appContentPreview: 'TPdys8PrTEaAs6rci5ulTQtt',
  appContentPublished: 'PUBnSr8lB5HCQ89YMWLJmQtt',
  partnerContentPreview: 'KyXPlMp99pqrPxkRolBZaQtt',
  partnerContentPublished: 'oRrC7S1yXKQ4i00u2zQDvAtt',
}

export default function createContentUrl(
  { isDraft, isPartnerPortalContent }: createContentUrlParams = {
    isDraft: false,
    isPartnerPortalContent: false,
  },
): ContentToken {
  const isDevOrVercel = config.data.environment() !== 'production'
  const previewToken = isPartnerPortalContent
    ? tokens.partnerContentPreview
    : tokens.appContentPreview
  const publishedToken = isPartnerPortalContent
    ? tokens.partnerContentPublished
    : tokens.appContentPublished
  const token = isDevOrVercel ? previewToken : publishedToken
  const version = isDraft ? 'draft' : 'published'
  const now = Date.now()
  const cv = isDevOrVercel ? now : getCv()

  return {
    token,
    version,
    cv,
    urlParams: `&token=${token}&version=${version}&cv=${cv}`,
  }
}
